var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "Message_list",
      staticClass: "Message",
      class: {
        "quote-focus":
          this.$store.state.chat.quoteMessageFocused &&
          this.$store.state.chat.quoteMessageFocused == _vm.message.messageId
      },
      attrs: { id: "msg-" + _vm.message.messageId }
    },
    [
      !_vm.message.isType
        ? _c("div", { staticClass: "Message-Message-left" }, [
            _c("p", { staticClass: "Message-Author" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.message.custNameNew == ""
                      ? _vm.message.custName
                      : _vm.message.custNameNew
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "bgImage",
                    rawName: "v-bgImage",
                    value: _vm.message.msg,
                    expression: "message.msg"
                  }
                ],
                staticClass: "Message-Content"
              },
              [
                _c(
                  "span",
                  { staticClass: "reply reply-left", on: { click: _vm.reply } },
                  [
                    _c("span", { attrs: { "uk-icon": "icon: reply;" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v(" Reply")])
                  ]
                ),
                _vm._v(" "),
                _vm.message.quotedMessageContent
                  ? _c(
                      "span",
                      {
                        staticClass: "quote-message",
                        on: {
                          click: function($event) {
                            return _vm.scrollToQuote(
                              _vm.message.quotedMessageId
                            )
                          }
                        }
                      },
                      [
                        _c("strong", [_vm._v("ข้อความ : ")]),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "msgChat",
                              rawName: "v-msgChat:html",
                              value: _vm.message.quotedMessageContent,
                              expression: "message.quotedMessageContent",
                              arg: "html"
                            }
                          ]
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "msgChat",
                      rawName: "v-msgChat:html",
                      value: _vm.message.msg,
                      expression: "message.msg",
                      arg: "html"
                    }
                  ],
                  staticClass: "msg"
                })
              ]
            ),
            _vm._v(" "),
            _c("small", {
              directives: [
                {
                  name: "time",
                  rawName: "v-time",
                  value: _vm.message.time,
                  expression: "message.time"
                }
              ]
            })
          ])
        : _c("div", { staticClass: "Message-Message-right" }, [
            _c("p", { staticClass: "Message-Author" }, [
              _c("strong", {
                directives: [
                  {
                    name: "nameChat",
                    rawName: "v-nameChat:html",
                    value: _vm.message,
                    expression: "message",
                    arg: "html"
                  }
                ]
              })
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "bgmsg",
                    rawName: "v-bgmsg",
                    value: _vm.message,
                    expression: "message"
                  }
                ],
                staticClass: "Message-Content"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "reply reply-right",
                    on: { click: _vm.reply }
                  },
                  [
                    _c("span", { attrs: { "uk-icon": "icon: reply;" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v(" Reply")])
                  ]
                ),
                _vm._v(" "),
                _vm.message.quotedMessageContent
                  ? _c(
                      "span",
                      {
                        staticClass: "quote-message",
                        on: {
                          click: function($event) {
                            return _vm.scrollToQuote(
                              _vm.message.quotedMessageId
                            )
                          }
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.message.quotedMessageSender.replace(
                                "{{customer}}",
                                "ลูกค้า"
                              )
                            ) + " : "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "msgChat",
                              rawName: "v-msgChat:html",
                              value: _vm.message.quotedMessageContent,
                              expression: "message.quotedMessageContent",
                              arg: "html"
                            }
                          ]
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.message.isUpload
                  ? _c("span", {
                      directives: [
                        {
                          name: "msgChat",
                          rawName: "v-msgChat:html",
                          value: _vm.message.msg,
                          expression: "message.msg",
                          arg: "html"
                        }
                      ],
                      staticClass: "msg"
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "small",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.message.statusSendMessage == false,
                    expression: "message.statusSendMessage == false"
                  }
                ],
                staticClass: "red",
                on: {
                  click: function($event) {
                    return _vm.fnReSendMessage(_vm.message)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-redo" }),
                _vm._v(" การส่งข้อมูลผิดพลาด")
              ]
            ),
            _vm._v(" "),
            _c("small", {
              directives: [
                {
                  name: "time",
                  rawName: "v-time",
                  value: _vm.message.time,
                  expression: "message.time"
                }
              ]
            })
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb6f00f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb6f00f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatMessage.vue
// module id = null
// module chunks = 